import { Mixins, Component } from 'vue-property-decorator';
import api from '@/api/question';
import { ITABLECOLCONF } from '@/types/base.d';
import pageMixin from '../../../mixins/pageMixin';

@Component
export default class tableMixin extends Mixins(pageMixin) {
  private mList: any = [];

  private column: Array<ITABLECOLCONF> = [{
    label: '内容',
    prop: 'content',
    align: 'center',
    tooltip: true,
  }, {
    label: '作业答案',
    align: 'center',
    prop: 'answer',
  }, {
    label: '题目类型',
    prop: 'questionTypeLabel',
    align: 'center',
  }, {
    label: '课程类型',
    prop: 'courseType',
    align: 'center',
  }, {
    label: '难易程度',
    prop: 'difficultyLabel',
    align: 'center',
  }, {
    label: '知识点',
    prop: 'knowledgeLabel',
    align: 'center',
  }, {
    label: '创建时间',
    align: 'center',
    custom: true,
    tag: {
      type: 'primary',
      prop: ['createTime'],
    },
  }, {
    label: '操作',
    custom: true,
    minWidth: '120',
    maxBtn: 2,
    btnList: [
      {
        title: '编辑',
        name: '/question/homework:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleUpdateForm,
        log: {
          name: '课后作业 - 编辑',
          component: 'org/manage/tableMixin',
        },
      },
      {
        title: '删除',
        name: '/question/homework:delete',
        icon: 'remove',
        type: 'info',
        callback: this.handleRmove,
        log: {
          name: '课后作业 - 删除',
          component: 'org/manage/tableMixin',
        },
      },
    ],
    align: 'center',
  }];

  private loading: boolean = true;

  mounted() {
    this.getData();
  }

  /* eslint-disable class-methods-use-this */
  handleUpdateForm(row: any) {}

  /* eslint-disable class-methods-use-this */
  /**
   * @author liangyongmou
   * @desc 获取课后作业列表
   */
  getData() {
    this.loading = true;
    api.getHomeWork(this.page).then((res: any) => {
      this.mList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  /**
   * @author liangyongmou
   * @desc 删除机构操作
   * @param { any } row 行数据
  */
  handleRmove(row: any) {
    this.confirm('此操作将永久删除该数据, 是否继续?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeHomeWork(row.pid).then(() => {
        this.getData();
        close();
        this.$log({
          title: '机构管理 - 删除 - 确定',
          component: 'org/manage/tableMixin',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 删除 - 取消',
      component: 'org/manage/tableMixin',
    }));
  }
}
